import React from 'react';
import moment from 'moment';

import api from '../../../api';
import strings from '../../../lang/lang';
import Button from '../../../elements/Button/Button';
import { showError, showSuccess } from '../../../elements/Toasts/toastActions';
import { setLoading } from '../../../redux/loading/loadingActions';
import { logout } from '../../../components/auth/redux/authActions';
import settings from '../Settings.module.scss';

const testWebhook = async ({ data, appId }) => {
  const { id, status, certificates  = []} = data;
  setLoading(true);

  try {
    const isCertificate = certificates.filter((c) => moment.utc(c.validUntil).isAfter(moment.utc()));
    if (status.toUpperCase() === 'PAUSED') {
      showError(strings.appWebhookDetails.errors.notSuccessTest);
      return;
    } else if (!isCertificate.length) {
      showError(strings.appWebhookDetails.errors.certRequiredForTest);
      return;
    }
    const webhookId = id;
    const result = await api.portal.testWebhook(appId, webhookId);

    if (result.status && Math.floor(result.status / 100) === 2) {
      showSuccess(strings.appWebhookDetails.text.successTest);
    } else {
      const response = await result.json();
      if (401 === result.status) {
        await logout();
      } else if (400 === result.status) {
        showError(response.message);
      } else {
        showError(strings.appWebhookDetails.errors.testingException);
      }
    }
  } catch (e) {
    showError(strings.appWebhookDetails.errors.testingException);
  } finally {
    setLoading(false);
  }
};

interface ITest {
  data: object;
  appId: string
}

function TestRequest(props: ITest) {
  return (
    <div className={settings.settings__pause_button_wrap}>
      <Button
        variant="primary"
        secondaryClassName="lg"
        type="button"
        onClick={() => testWebhook(props)}
      >
        {strings.appWebhookDetails.buttons.test}
      </Button>
    </div>
  );
}

export default TestRequest;
